import { getFirestore } from 'firebase/firestore';
import initializeFirebase from '../common/firebase/firebase.init';

export const myFirestore = getFirestore(initializeFirebase);
